<nav class="swiper swiper-sub-categories is-flex">
    <div class="swiper-nav swiper-category-nav-left swiper-{{ uuid }}-nav-left mr-20 icon-white">
        <md-icon [name]="direction() === 'rtl' ? 'chevron-right' : 'chevron-left'"></md-icon>
    </div>

    <!-- Listado de subcategorías -->
    <div class="swiper swiper-categories tabs" [dir]="direction()" [ngClass]="swiperCategoriesClass">
        @if (isNormalBehavior()) {
            <ul class="swiper-wrapper">
                @for (category of siblingCategories(); track $index) {
                    <li class="swiper-slide" [ngClass]="[category.id === currentCategoryFromABTest().id ? 'is-active' : '  ']">
                        @if (!isNoindex) {
                            <a
                                elementObserverDirective
                                class="swiper text-l ttu blend-link"
                                [ngClass]="[category.className ? category.className : '']"
                                [href]="category.locationPath"
                                [title]="category.name + ' ' + lastSectionTranslated()"
                                [observeType]="'promotion'"
                                [observeLink]="{ categoryId: category?.id }"
                                (click)="goToCategory(category, $event)"
                            >
                                <!-- p-m -->
                                {{ category.name }}
                                @if (showDebugCategoryIds()) {
                                    <category-debug [info]="'(' + category.id + ')'" [template]="'parenthesis'"></category-debug>
                                }
                                @if (category.isNew || category.freeTextAttachments.length > 0) {
                                    <div class="ml-8">
                                        @if (category.isNew) {
                                            <div class="mr-8 title-s ttu">NEW</div>
                                        }
                                        @for (freeTextAttachment of category.freeTextAttachments; track $index) {
                                            <div class="mr-8 text-l ttu">
                                                {{ freeTextAttachment.path }}
                                            </div>
                                        }
                                    </div>
                                }
                            </a>
                        }

                        @if (isNoindex) {
                            <button
                                elementObserverDirective
                                class="btn swiper text-l ttu blend-link"
                                [ngClass]="[category.className ? category.className : '']"
                                [title]="category.name + ' ' + lastSectionTranslated()"
                                [observeType]="'promotion'"
                                [observeLink]="{ categoryId: category?.id }"
                                (click)="goToCategory(category, $event)"
                            >
                                <!-- p-m -->
                                {{ category.name }}
                                @if (showDebugCategoryIds()) {
                                    <category-debug [info]="'(' + category.id + ')'" [template]="'parenthesis'"></category-debug>
                                }
                                @if (category.isNew || category.freeTextAttachments.length > 0) {
                                    <div class="ml-8">
                                        @if (category.isNew) {
                                            <div class="mr-8 title-s ttu">NEW</div>
                                        }
                                        @for (freeTextAttachment of category.freeTextAttachments; track $index) {
                                            <div class="mr-8 text-l ttu">
                                                {{ freeTextAttachment.path }}
                                            </div>
                                        }
                                    </div>
                                }
                            </button>
                        }
                    </li>
                }
            </ul>
        }

        <!-- Se muestran las subcategorías a partir del filtro asignado a esta categoría -->
        @if (!isNormalBehavior()) {
            <ul class="swiper-wrapper">
                @for (filter of filtersArray(); track $index) {
                    <li class="swiper-slide">
                        <span class="align-middle" (click)="updateFilter(filter.name)">
                            <span class="text-l pt-8 pr-16 pb-8">
                                <span
                                    class="text-l text-l link-raw blend-link"
                                    [ngClass]="currentCategoryFromABTest().className"
                                    elementObserverDirective
                                    [observeType]="'promotion'"
                                    [observeLink]="{ categoryId: currentCategoryFromABTest()?.id }"
                                >
                                    {{ filter.value }}
                                </span>
                            </span>
                        </span>
                    </li>
                }
            </ul>
        }
    </div>

    <div class="swiper-nav swiper-category-nav-right swiper-{{ uuid }}-nav-right ml-20 icon-white">
        <md-icon [name]="direction() === 'rtl' ? 'chevron-left' : 'chevron-right'"></md-icon>
    </div>
</nav>
